import Banner from "../imgs/banner.png";

const ItemListSectionDecorator = () => (
  <div className="mb-8">
    <img className="rounded-2xl w-full" src={Banner} alt="banner" />
  </div>
);

export default ItemListSectionDecorator;
